import { useSelector, useDispatch } from 'react-redux';
import { authActions } from '../store/slices/auth-slices';

export const useAuth = () => {
    const dispatch = useDispatch();
    const authState = useSelector(state => state.auth);

    const sendOtp = (phoneData) => dispatch(authActions.sendOtp(phoneData));
    const verifyOtp = (otpData) => dispatch(authActions.verifyOtp(otpData));
    const firebaseSignIn = (firebaseData) => dispatch(authActions.firebaseSignIn(firebaseData));
    const getMe = () => dispatch(authActions.getMe());
    const logout = () => dispatch(authActions.logout());
    const clearError = () => dispatch(authActions.clearError());
    const resetAuthState = () => dispatch(authActions.resetAuthState());
    const initializeAuth = () => dispatch(authActions.initializeAuth());

    return {
        ...authState,
        sendOtp,
        verifyOtp,
        firebaseSignIn,
        getMe,
        logout,
        clearError,
        resetAuthState,
        initializeAuth,
    };
}; 